import { Component, ojs, app, v, state, payload } from "modular-openscriptjs";
import {
    pageInfo,
    getGreetings,
    formatThousand,
    either,
    isMobile,
    scrollToTop,
    cleanDispose,
    eParse,
    inform,
    updateStateValue,
    acknowledge,
} from "../../helpers";
import { gc, api, STRINGS } from "../../declarations";
import { dom, tool } from "../../fotastart";
import { $e } from "../../ojs.events";
import Announcements from "../Announcements";
import { businessWhatsappHref } from "../../shareLink";
import SolidIcon from "../Blocks/SolidIcon";
import AiCreditCard from "../Blocks/AiCreditCard";
import OffcanvasBody from "../Offcanvas/OffcanvasBody";
import ModalBody from "../Modals/ModalBody";
import Spinner from "../Blocks/Spinner";
import CheckYesno from "../Blocks/CheckYesno";

const h = app("h");
const broker = app("broker");

ojs(
    Announcements,
    SolidIcon,
    AiCreditCard,
    OffcanvasBody,
    ModalBody,
    Spinner,
    CheckYesno,
);

export default class AuthenticatedIndex extends Component {
    stats = state({
        total_revenue_month: 0,
        total_orders_month: 0,
        active_customers_count: 0,
        avg_rating: 0,
    });
    loadingStats = state(true);

    businessOnline = state(true);
    loadingBusinessStatus = state(true);

    deliveryFormStep = state(1);
    deliveryBranches = state([]);
    deliveryLoadingBranches = state(false);
    deliveryForm = state({
        branch_id: "",
        dropoff_address: "",
        latitude: "",
        longitude: "",
        contact_name: "",
        contact_phone: "",
    });
    deliveryFee = state(null);
    deliveryLoadingFee = state(false);
    deliveryDistance = state(null);
    deliveryDuration = state(null);
    deliveryFeeError = state(null);
    pickedLocation = state("");
    deliveryHolder = null;

    constructor() {
        super();
        this.stats.listener(this);
        this.loadingStats.listener(this);
        this.businessOnline.listener(this);
        this.loadingBusinessStatus.listener(this);
    }

    $$branch = {
        updated: () => this.fetchBusinessOnlineStatus(),
    };

    // Lets the voice agent open/close this same form via
    // OpenPickupDropoffForm/ClosePickupDropoffForm (see
    // BusinessVoiceOrderCall.js's performFrontendToolAction), the same
    // event names and shape app.carata's DeliveryRequestForm.js listens
    // for - the "Request a Delivery" button above calls openDeliveryForm()
    // directly, this is the second, voice-driven way in.
    $$deliveryRequest = {
        needs: {
            requestForm: () => this.openDeliveryForm(),
            closeRequestForm: () => this.deliveryHolder?.hide(),
        },
    };

    $$map = {
        has: {
            location: (ed) => {
                let { meta, message } = eParse(ed);

                if (meta.from !== "DELIVERY_REQUEST_FORM") return;

                updateStateValue(this.deliveryForm, (v) => {
                    v.latitude = message.latitude;
                    v.longitude = message.longitude;
                    v.dropoff_address = message.address;
                    return v;
                });
                this.pickedLocation.value = message.address;

                inform("Location selected!", STRINGS.SUCCESS);

                const selectedBranch = this.deliveryBranches.value.find(
                    (b) => b.id == this.deliveryForm.value.branch_id,
                );
                this.recalculateDeliveryFee(
                    selectedBranch,
                    message.latitude,
                    message.longitude,
                );
            },
        },
    };

    /**
     * "Share on WhatsApp" next to the business name: owners promote their shop
     * to customers, so it is a bright, labelled button rather than a bare icon.
     * The link is https://app.carata.co/business/{handle}.
     */
    renderShareButton() {
        const href = businessWhatsappHref(window.currentCompany);
        if (!href) return h.empty();

        return h.a(
            {
                href,
                target: "_blank",
                rel: "noopener",
                title: "Share your business on WhatsApp",
                class: "btn btn-sm rounded-pill px-3 py-1 fw-bold shadow d-inline-flex align-items-center gap-2 text-white",
                style: "background-color: #25D366; border-color: #25D366;",
            },
            h.i({ class: "bi bi-whatsapp" }),
            "Share",
        );
    }

    render() {
        const user = gc.user.value;
        const businessName = window.currentCompany?.name || "Your Business";

        pageInfo(`Dashboard - ${businessName}`);
        scrollToTop();

        if (this.loadingStats.value && window.currentCompany?.id) {
            this.fetchStats();
        }

        if (this.loadingBusinessStatus.value && window.currentCompany?.id) {
            this.fetchBusinessOnlineStatus();
        }

        return h.div(
            { class: "py-5 min-vh-100 mb-5" },
            h.div(
                { class: "container" },
                // Mobile View
                h.div(
                    { class: "d-block d-lg-none" },
                    // Header / Business Name
                    h.div(
                        { class: "mb-4" },
                        h.h6(
                            {
                                class: "text-primary fw-bold text-uppercase small mb-1",
                            },
                            getGreetings(),
                        ),
                        h.div(
                            {
                                class: "d-flex align-items-center flex-wrap gap-2",
                            },
                            h.h2({ class: "fw-bold mb-0" }, businessName),
                            this.renderShareButton(),
                        ),
                    ),

                    // Business Status (Go Online / Offline)
                    this.renderBusinessStatusCard(),

                    // Announcements
                    h.Announcements({ $class: "mb-4 d-none" }),

                    // Quick Actions
                    h.div(
                        { class: "mb-4 mt-3" },
                        h.h5({ class: "fw-bold mb-3" }, "Quick Actions"),
                        this.renderVoiceModeCard(),
                        h.div(
                            { class: "row g-3" },
                            this.renderActionCard(
                                "Request Delivery",
                                "Deliver a package",
                                "truck",
                                "morning",
                                this.method("openDeliveryForm"),
                            ),
                            this.renderActionCard(
                                "Inventory",
                                "View products by category",
                                "box-seam",
                                "primary",
                                h.func(
                                    "app('router').to",
                                    "business.manage.inventory",
                                    { companyId: window.currentCompany?.id },
                                ),
                            ),
                            this.renderActionCard(
                                "Orders",
                                "Process customer orders",
                                "clipboard-check",
                                "success",
                                h.func("app('router').to", "orders"),
                            ),
                            this.renderActionCard(
                                "Performance",
                                "See revenue, orders, ...",
                                "graph-up",
                                "info",
                                h.func(
                                    "app('router').to",
                                    "business.analytics",
                                ),
                            ),
                        ),
                    ),

                    // AI Credit Card
                    h.AiCreditCard(),

                    // Stats Grid
                    v(this.stats, (s) =>
                        h.div(
                            { class: "" },
                            h.h5(
                                { class: "fw-bold mb-3" },
                                "Performance This Month",
                            ),
                            h.div(
                                { class: "row g-3 mb-4" },
                                this.renderStatCard(
                                    "Orders",
                                    s.value.total_orders_month,
                                    "cart-check",
                                    "primary",
                                ),
                                this.renderStatCard(
                                    "Total Revenue",
                                    `KES ${formatThousand(
                                        s.value.total_revenue_month,
                                    )}`,
                                    "currency-dollar",
                                    "success",
                                ),
                                this.renderStatCard(
                                    "Active Customers",
                                    s.value.active_customers_count,
                                    "people",
                                    "info",
                                ),
                                this.renderStatCard(
                                    "Avg Rating (3mo)",
                                    s.value.avg_rating.toFixed(1),
                                    "star-fill",
                                    "warning",
                                ),
                            ),
                        ),
                    ),
                ),

                // Desktop / Large Screen View
                h.div(
                    { class: "d-none d-lg-block" },
                    h.div(
                        { class: "row g-4" },
                        // Main Column
                        h.div(
                            { class: "col-lg-7 col-xl-8" },
                            // Header / Business Name
                            h.div(
                                { class: "mb-4" },
                                h.h6(
                                    {
                                        class: "text-primary fw-bold text-uppercase small mb-1",
                                    },
                                    getGreetings(),
                                ),
                                h.div(
                            {
                                class: "d-flex align-items-center flex-wrap gap-2",
                            },
                            h.h2({ class: "fw-bold mb-0" }, businessName),
                            this.renderShareButton(),
                        ),
                            ),

                            // Business Status (Go Online / Offline)
                            this.renderBusinessStatusCard(),

                            // Quick Actions
                            h.div(
                                { class: "mb-4" },
                                h.h5(
                                    { class: "fw-bold mb-3" },
                                    "Quick Actions",
                                ),
                                this.renderVoiceModeCard(),
                                h.div(
                                    { class: "row g-3" },
                                    this.renderActionCard(
                                        "Request Pickup",
                                        "Fast delivery requests",
                                        "truck",
                                        "morning",
                                        this.method("openDeliveryForm"),
                                        "col-6",
                                    ),
                                    this.renderActionCard(
                                        "Inventory",
                                        "View products by category",
                                        "box-seam",
                                        "primary",
                                        h.func(
                                            "app('router').to",
                                            "business.manage.inventory",
                                            {
                                                companyId:
                                                    window.currentCompany?.id,
                                            },
                                        ),
                                        "col-6",
                                    ),
                                    this.renderActionCard(
                                        "Orders",
                                        "Process customer orders",
                                        "clipboard-check",
                                        "success",
                                        h.func("app('router').to", "orders"),
                                        "col-6",
                                    ),
                                    this.renderActionCard(
                                        "Performance",
                                        "See revenue, orders, ...",
                                        "graph-up",
                                        "info",
                                        h.func(
                                            "app('router').to",
                                            "business.analytics",
                                        ),
                                        "col-6",
                                    ),
                                ),
                            ),

                            // Stats Grid
                            v(this.stats, (s) =>
                                h.div(
                                    { class: "" },
                                    h.h5(
                                        { class: "fw-bold mb-3" },
                                        "Performance This Month",
                                    ),
                                    h.div(
                                        { class: "row g-3" },
                                        this.renderStatCard(
                                            "Orders",
                                            s.value.total_orders_month,
                                            "cart-check",
                                            "primary",
                                            "col-6",
                                        ),
                                        this.renderStatCard(
                                            "Total Revenue",
                                            `KES ${formatThousand(
                                                s.value.total_revenue_month,
                                            )}`,
                                            "currency-dollar",
                                            "success",
                                            "col-6",
                                        ),
                                        this.renderStatCard(
                                            "Active Customers",
                                            s.value.active_customers_count,
                                            "people",
                                            "info",
                                            "col-6",
                                        ),
                                        this.renderStatCard(
                                            "Avg Rating (3mo)",
                                            s.value.avg_rating.toFixed(1),
                                            "star-fill",
                                            "warning",
                                            "col-6",
                                        ),
                                    ),
                                ),
                            ),
                        ),

                        // Sidebar (Announcements + AI Credit Card)
                        h.div(
                            { class: "col-lg-5 col-xl-4" },
                            h.div(
                                {
                                    class: "position-sticky",
                                    style: "top: 2rem;",
                                },
                                h.h5(
                                    { class: "fw-bold mb-3" },
                                    "Announcements",
                                ),
                                h.div(
                                    { class: "mb-4" },
                                    h.Announcements({ $class: "d-block" }),
                                ),
                                h.div({ class: "mb-4" }, h.AiCreditCard()),
                            ),
                        ),
                    ),
                ),
            ),
        );
    }

    renderActionCard(
        title,
        description,
        icon,
        color,
        onclick,
        colClass = "col-6",
    ) {
        const isCustomColor = color === "morning";
        const rgbVar = isCustomColor
            ? "var(--ca-morning-rgb)"
            : `var(--bs-${color}-rgb)`;
        const iconColor = isCustomColor ? "#d9a406" : `var(--bs-${color})`;

        return h.div(
            { class: colClass },
            h.div(
                {
                    class: "card border-0 rounded-4 cursor-pointer hover-shadow transition-all h-100",
                    style: `background-color: rgba(${rgbVar}, 0.15); color: black;`,
                    onclick: onclick,
                    role: "button",
                },
                h.div(
                    {
                        class: "card-body p-3 text-center d-flex flex-column align-items-center justify-content-center",
                    },
                    h.div(
                        {
                            class: "bg-white rounded-circle circle d-inline-flex p-3 mb-2 shadow-sm",
                            style: `color: ${iconColor};`,
                        },
                        h.i({ class: `bi bi-${icon} fs-2` }),
                    ),
                    h.h5({ class: "fw-bold mb-1" }, title),
                    h.p(
                        {
                            class: "small mb-0 opacity-75 fw-500",
                            style: "font-size: 0.75rem;",
                        },
                        description,
                    ),
                ),
            ),
        );
    }

    renderVoiceModeCard() {
        return h.div(
            {
                class: "card border-0 rounded-4 shadow-sm mb-3 voice-mode-action-card overflow-hidden",
                style: "background: linear-gradient(135deg, rgba(52, 211, 153, 0.12) 0%, rgba(5, 150, 105, 0.08) 100%); border: 1px solid rgba(5, 150, 105, 0.2) !important; cursor: pointer;",
                onclick: h.func("fireEvent", $e.voiceOrderCall.needs.start),
                role: "button",
            },
            h.div(
                {
                    class: "card-body p-3 p-md-4 d-flex align-items-center justify-content-between gap-3",
                },
                h.div(
                    { class: "d-flex align-items-center gap-3" },
                    h.div(
                        {
                            class: "rounded-circle d-flex align-items-center justify-content-center text-white flex-shrink-0 shadow-sm",
                            style: "width: 52px; height: 52px; background: linear-gradient(135deg, #34d399 0%, #059669 100%);",
                        },
                        h.i({ class: "bi bi-telephone-fill fs-4" }),
                    ),
                    h.div(
                        h.div(
                            { class: "d-flex align-items-center gap-2 mb-1" },
                            h.h5({ class: "fw-bold mb-0 text-dark" }, "Voice Mode"),
                            h.span(
                                {
                                    class: "badge rounded-pill text-white fw-semibold d-inline-flex align-items-center gap-1",
                                    style: "background: #059669; font-size: 0.68rem; padding: 3px 8px;",
                                },
                                h.i({ class: "bi bi-stars" }),
                                "AI Call",
                            ),
                        ),
                        h.p(
                            {
                                class: "small text-secondary mb-0 fw-medium",
                                style: "font-size: 0.82rem; line-height: 1.35;",
                            },
                            "Talk to Carata to add products, request delivery, check orders, get reports, insight, and all of that.",
                        ),
                    ),
                ),
                h.div(
                    {
                        class: "d-none d-sm-flex align-items-center justify-content-center text-secondary opacity-50",
                    },
                    h.i({ class: "bi bi-chevron-right fs-5" }),
                ),
            ),
        );
    }

    renderStatCard(title, value, icon, color, colClass = "col-6 col-lg-3") {
        return h.div(
            { class: colClass },
            h.div(
                { class: "card border shadow-sm rounded-4 h-100" },
                h.div(
                    { class: "card-body p-3" },
                    h.div(
                        {
                            class: `bg-${color}-subtle text-${color} rounded-3 d-inline-flex p-2 mb-2`,
                        },
                        h.i({ class: `bi bi-${icon} fs-5` }),
                    ),
                    h.p(
                        {
                            class: "text-muted small fw-bold text-uppercase mb-1",
                        },
                        title,
                    ),
                    h.h4({ class: "fw-bold mb-0" }, value),
                ),
            ),
        );
    }

    async fetchStats() {
        try {
            const res = await api.get(
                `companies/${window.currentCompany.id}/performance-summary`,
                {},
                { silent: true },
            );
            if (res) {
                this.stats.value = res.data;
            }
        } catch (e) {
            console.error("Failed to fetch stats", e);
        } finally {
            this.loadingStats.value = false;
        }
    }

    renderBusinessStatusCard() {
        return v(this.businessOnline, (o) => {
            const online = o.value;

            return h.div(
                { class: "mb-4" },
                h.div(
                    {
                        class: `card border-0 rounded-4 ${online ? "bg-success-subtle" : "bg-danger-subtle"}`,
                    },
                    h.div(
                        {
                            class: "card-body p-3 d-flex align-items-center gap-3",
                        },
                        h.div(
                            {
                                class: `bg-white circle p-3 ${online ? "text-success" : "text-danger"}`,
                            },
                            h.i({
                                class: `bi ${online ? "bi-shop" : "bi-shop-window"} fs-4`,
                            }),
                        ),
                        h.div(
                            { class: "flex-fill" },
                            h.h6({ class: "fw-bold mb-1" }, "Business Status"),
                            h.p(
                                { class: "small mb-0 fw-500" },
                                online
                                    ? "You're open — customers can find you and place orders."
                                    : "You're offline — customers can't find your business or place new orders.",
                            ),
                        ),
                    ),
                    h.div(
                        { class: "mt-1" },
                        h.CheckYesno(
                            {
                                id: `business-status-${this.id}`,
                                checked: online,
                                label: {
                                    value: "Open for Orders",
                                    class: "small fw-bold",
                                },
                                onchange: this.method("toggleBusinessStatus", [
                                    "${this}",
                                ]),
                            },
                            {
                                class: "check-yesno-end d-flex justify-content-between align-items-center px-3 pb-3",
                            },
                        ),
                    ),
                ),
            );
        });
    }

    async fetchBusinessOnlineStatus() {
        if (!window.currentCompany?.id) return;

        this.loadingBusinessStatus.value = true;

        try {
            const res = await api.get(
                `companies/${window.currentCompany.id}/branches`,
                {},
                { silent: true },
            );

            if (res) {
                const branches = res.data.branches ?? [];
                this.businessOnline.value =
                    branches.length > 0 && branches.every((b) => b.is_online);
            }
        } catch (e) {
            console.error("Failed to fetch business online status", e);
        } finally {
            this.loadingBusinessStatus.value = false;
        }
    }

    toggleBusinessStatus(elem) {
        if (!window.currentCompany?.id) return;

        broker.send(
            $e.branch.needs.bulkToggleOnline,
            payload({
                businessId: window.currentCompany.id,
                is_online: elem.checked,
            }),
        );

        // Going offline requires confirmation (handled in BranchMediator),
        // which can be declined after the checkbox has already flipped
        // visually. Resync shortly after so the toggle reflects what
        // actually happened on the server either way.
        setTimeout(() => this.fetchBusinessOnlineStatus(), 1200);
    }

    openDeliveryForm() {
        if (this.deliveryHolder) cleanDispose(this.deliveryHolder);

        if (
            this.deliveryBranches.value.length === 0 &&
            !this.deliveryLoadingBranches.value
        ) {
            this.fetchDeliveryBranches();
        }

        const form = () => this.renderDeliveryForm();

        if (isMobile()) {
            this.deliveryHolder = tool.offcanvas(h.OffcanvasBody(form()), {
                class: "rounded-top-5 shadow-lg",
                style: "height: auto; max-height: 85vh;",
            });
        } else {
            this.deliveryHolder = tool.plainModal(h.ModalBody(form()));
        }

        this.deliveryHolder.show();
    }

    async fetchDeliveryBranches() {
        if (!window.currentCompany?.id) return;
        this.deliveryLoadingBranches.value = true;
        try {
            const res = await api.get(
                `companies/${window.currentCompany.id}/branches`,
                {},
                { silent: true },
            );
            if (res) {
                this.deliveryBranches.value = res.data.branches;
                if (res.data.branches.length > 0) {
                    updateStateValue(this.deliveryForm, (v) => {
                        v.branch_id = res.data.branches[0].id;
                        return v;
                    });
                }
            }
        } catch (e) {
            console.error("Failed to fetch branches for delivery request", e);
        } finally {
            this.deliveryLoadingBranches.value = false;
        }
    }

    openMap() {
        broker.send(
            $e.location.is.needed,
            payload({}, { from: "DELIVERY_REQUEST_FORM" }),
        );
    }

    async recalculateDeliveryFee(pickupBranch, dropoffLat, dropoffLng) {
        if (!pickupBranch) return;
        this.deliveryLoadingFee.value = true;
        this.deliveryFee.value = null;
        this.deliveryDistance.value = null;
        this.deliveryDuration.value = null;
        this.deliveryFeeError.value = null;
        try {
            const res = await api.get(
                `companies/${window.currentCompany.id}/branch/${pickupBranch.id}/delivery-requests/estimate-fee`,
                {
                    dropoff_lat: dropoffLat,
                    dropoff_lng: dropoffLng,
                },
                { silent: true },
            );

            if (res && res.data) {
                if (
                    res.data.status === "distance_limit_exceeded" ||
                    res.data.status === "no_deliverer_available"
                ) {
                    this.deliveryFeeError.value = res.data.message;
                } else if (res.data.estimated_fee !== undefined) {
                    this.deliveryFee.value = res.data.estimated_fee;
                    this.deliveryDistance.value = res.data.distance;
                    this.deliveryDuration.value = res.data.duration;
                } else {
                    inform("Failed to calculate delivery fee.", STRINGS.ERROR);
                }
            } else {
                inform("Failed to calculate delivery fee.", STRINGS.ERROR);
            }
        } catch (e) {
            inform(
                "Could not estimate delivery fee. Please try again.",
                STRINGS.ERROR,
            );
        } finally {
            this.deliveryLoadingFee.value = false;
        }
    }

    async submitDeliveryRequest() {
        const {
            branch_id,
            dropoff_address,
            latitude,
            longitude,
            contact_name,
            contact_phone,
        } = this.deliveryForm.value;

        if (!contact_name || !contact_name.trim()) {
            inform("Recipient name is required.", STRINGS.ERROR);
            return;
        }
        if (!contact_phone || !contact_phone.trim()) {
            inform("Recipient phone number is required.", STRINGS.ERROR);
            return;
        }

        const submitBtn = dom.get(`[hook="submit-delivery-btn-${this.id}"]`);
        if (submitBtn) {
            dom.disable(submitBtn);
            h.Spinner({ parent: submitBtn, resetParent: true });
        }

        try {
            let res = await api.post(
                `companies/${window.currentCompany.id}/branch/${branch_id}/delivery-requests`,
                {
                    dropoff_latitude: latitude,
                    dropoff_longitude: longitude,
                    recipient_name: contact_name,
                    recipient_number: contact_phone,
                },
            );

            if (!res) {
                return;
            }

            acknowledge({
                title: "Thank You!",
                message:
                    "We have received your request. Our deliverer will arrive soon for pickup.",
                close_text: "Perfect",
            });

            this.deliveryHolder?.hide();
            this.resetDeliveryForm();
        } catch (e) {
            inform("Error placing request", STRINGS.ERROR);
        } finally {
            if (submitBtn) {
                dom.enable(submitBtn);
                dom.put("Request Delivery", submitBtn);
            }
        }
    }

    resetDeliveryForm() {
        this.deliveryFormStep.value = 1;
        this.pickedLocation.value = "";
        this.deliveryFee.value = null;
        this.deliveryDistance.value = null;
        this.deliveryDuration.value = null;
        this.deliveryFeeError.value = null;
        updateStateValue(this.deliveryForm, (v) => {
            v.branch_id = this.deliveryBranches.value[0]?.id || "";
            v.dropoff_address = "";
            v.latitude = "";
            v.longitude = "";
            v.contact_name = "";
            v.contact_phone = "";
            return v;
        });
    }

    cleanUp() {
        super.cleanUp();
        if (this.deliveryHolder) {
            cleanDispose(this.deliveryHolder);
        }
    }

    renderDeliveryForm() {
        return h.div(
            { class: "p-3" },
            h.div(
                {
                    class: "d-flex justify-content-between align-items-center mb-4",
                },
                h.h4(
                    { class: "fw-bold mb-0 text-primary" },
                    "Request a Delivery",
                ),
                h.button({
                    type: "button",
                    class: "btn-close",
                    listeners: {
                        click: () => this.deliveryHolder?.hide(),
                    },
                }),
            ),
            this.renderDeliveryProgress(),
            v(this.deliveryFormStep, (step) => {
                switch (step.value) {
                    case 1:
                        return this.renderStep1();
                    case 2:
                        return this.renderStep2();
                    case 3:
                        return this.renderStep3();
                    default:
                        return null;
                }
            }),
        );
    }

    renderDeliveryProgress() {
        return h.div(
            { class: "mb-4 text-center" },
            h.div(
                {
                    class: "d-flex justify-content-center align-items-center gap-2 gap-md-3 mb-2",
                },
                [1, 2, 3].map((i) =>
                    v(this.deliveryFormStep, (step) =>
                        h.div(
                            {
                                class: `rounded-circle d-flex align-items-center justify-content-center fw-bold transition-all ${
                                    step.value === i
                                        ? "bg-primary text-white shadow"
                                        : step.value > i
                                          ? "bg-success text-white"
                                          : "bg-white text-muted border"
                                }`,
                                style: "width: 35px; height: 35px; font-size: 0.9rem;",
                            },
                            step.value > i
                                ? h.i({ class: "bi bi-check-lg" })
                                : i,
                        ),
                    ),
                ),
            ),
            v(this.deliveryFormStep, (step) =>
                h.h6(
                    {
                        class: "text-muted text-uppercase fw-bold small",
                        style: "font-size: 0.75rem; letter-spacing: 0.5px;",
                    },
                    `Step ${step.value} of 3`,
                ),
            ),
        );
    }

    renderStep1() {
        return h.div(
            { class: "animate-step" },
            h.h5({ class: "fw-bold mb-3 text-dark" }, "Select Pickup Branch"),
            h.p(
                { class: "text-muted small mb-4" },
                "Choose the branch where the delivery person will pick up the package.",
            ),
            v(this.deliveryLoadingBranches, (loading) => {
                if (loading.value) {
                    return h.div({ class: "text-center py-4" }, h.Spinner());
                }

                return v(this.deliveryBranches, (branches) => {
                    if (branches.value.length === 0) {
                        return h.div(
                            { class: "text-center py-3" },
                            h.p(
                                { class: "text-secondary small" },
                                "No branches found. Please set up a branch first.",
                            ),
                        );
                    }

                    return v(this.deliveryForm, (formVal) => {
                        return h.div(
                            { class: "d-grid gap-2 mb-4" },
                            ...branches.value.map((b) => {
                                const isSelected = formVal.branch_id == b.id;
                                return h.button(
                                    {
                                        class: `btn p-3 rounded-4 text-start border-2 transition-all d-flex align-items-center justify-content-between ${
                                            isSelected
                                                ? "btn-outline-primary border-primary bg-primary-subtle"
                                                : "btn-outline-secondary border-light-subtle bg-white text-dark"
                                        }`,
                                        listeners: {
                                            click: () => {
                                                updateStateValue(
                                                    this.deliveryForm,
                                                    (v) => {
                                                        v.branch_id = b.id;
                                                        return v;
                                                    },
                                                );
                                                if (
                                                    this.deliveryForm.value
                                                        .latitude &&
                                                    this.deliveryForm.value
                                                        .longitude
                                                ) {
                                                    this.recalculateDeliveryFee(
                                                        b,
                                                        this.deliveryForm.value
                                                            .latitude,
                                                        this.deliveryForm.value
                                                            .longitude,
                                                    );
                                                }
                                            },
                                        },
                                    },
                                    h.div(
                                        {},
                                        h.div({ class: "fw-bold" }, b.name),
                                        b.readable_address
                                            ? h.small(
                                                  { class: "text-muted" },
                                                  b.readable_address,
                                              )
                                            : null,
                                    ),
                                    isSelected
                                        ? h.i({
                                              class: "bi bi-check-circle-fill text-primary fs-5",
                                          })
                                        : h.i({
                                              class: "bi bi-circle text-muted fs-5",
                                          }),
                                );
                            }),
                        );
                    });
                });
            }),
            h.div(
                { class: "d-flex justify-content-end mt-4 pt-2" },
                h.button(
                    {
                        type: "button",
                        class: "btn btn-primary rounded-pill px-4",
                        listeners: {
                            click: () => {
                                if (!this.deliveryForm.value.branch_id) {
                                    inform(
                                        "Please select a branch first.",
                                        STRINGS.ERROR,
                                    );
                                    return;
                                }
                                this.deliveryFormStep.value = 2;
                            },
                        },
                    },
                    "Next Step",
                    h.i({ class: "bi bi-arrow-right ms-2" }),
                ),
            ),
        );
    }

    renderStep2() {
        const selectedBranch = this.deliveryBranches.value.find(
            (b) => b.id == this.deliveryForm.value.branch_id,
        );
        const branchName = selectedBranch
            ? selectedBranch.name
            : "Selected Branch";

        return h.div(
            { class: "animate-step" },
            h.h5({ class: "fw-bold mb-3 text-dark" }, "Select Dropoff Address"),

            h.div(
                { class: "card border-0 bg-light p-3 rounded-4 mb-4" },
                h.div(
                    { class: "small text-muted text-uppercase fw-bold mb-1" },
                    "Pickup From",
                ),
                h.div(
                    {
                        class: "fw-bold text-dark d-flex align-items-center gap-2",
                    },
                    h.i({ class: "bi bi-geo-alt text-primary" }),
                    branchName,
                ),
            ),

            h.div(
                { class: "mb-4" },
                h.label(
                    {
                        class: "form-label small text-uppercase fw-bold text-muted",
                    },
                    "Dropoff Location",
                ),

                v(this.pickedLocation, (p) => {
                    if (p.value) {
                        return h.div(
                            {
                                class: "p-3 bg-light rounded-4 border border-light-subtle d-flex align-items-center justify-content-between mb-3",
                            },
                            h.div(
                                { class: "pe-3" },
                                h.div(
                                    {
                                        class: "small text-muted text-uppercase fw-bold mb-1",
                                        style: "font-size: 0.75rem;",
                                    },
                                    "Selected Address:",
                                ),
                                h.div(
                                    { class: "fw-bold text-dark fs-6" },
                                    p.value,
                                ),
                            ),
                            h.button(
                                {
                                    class: "btn btn-outline-primary rounded-circle p-2 d-flex align-items-center justify-content-center border-2",
                                    style: "width: 40px; height: 40px; min-width: 40px;",
                                    listeners: {
                                        click: () => this.openMap(),
                                    },
                                    title: "Change Location",
                                },
                                h.i({ class: "bi bi-geo-alt-fill fs-5" }),
                            ),
                        );
                    }

                    return h.button(
                        {
                            class: "btn btn-outline-primary d-flex align-items-center gap-2 w-100 justify-content-center py-3 rounded-4 border-2 mb-3",
                            style: "border-style: dashed;",
                            listeners: {
                                click: () => this.openMap(),
                            },
                        },
                        h.i({ class: "bi bi-geo-alt-fill fs-5" }),
                        "Pick Location on Map",
                    );
                }),

                v(this.deliveryLoadingFee, (loadingFee) => {
                    if (loadingFee.value) {
                        return h.div(
                            { class: "text-center py-3 mb-3" },
                            h.Spinner(),
                        );
                    }

                    return h.div(
                        {},
                        v(this.deliveryFeeError, (err) => {
                            if (err.value) {
                                return h.div(
                                    {
                                        class: "p-3 rounded-4 border border-danger-subtle bg-danger bg-opacity-10 mb-3 d-flex align-items-center gap-2",
                                    },
                                    h.i({
                                        class: "bi bi-exclamation-triangle-fill text-danger fs-5",
                                    }),
                                    h.div(
                                        {
                                            class: "text-danger small fw-semibold",
                                        },
                                        err.value,
                                    ),
                                );
                            }
                            return null;
                        }),
                        v(this.deliveryFee, (fee) => {
                            if (fee.value) {
                                return h.div(
                                    {
                                        class: "d-flex align-items-center justify-content-between p-3 rounded-4 border border-success-subtle bg-success bg-opacity-10 mb-3",
                                        style: "border-width: 1px !important;",
                                    },
                                    h.div(
                                        {
                                            class: "d-flex align-items-center gap-3",
                                        },
                                        h.div(
                                            {
                                                class: "bg-success text-white rounded-circle d-flex align-items-center justify-content-center",
                                                style: "width: 40px; height: 40px;",
                                            },
                                            h.i({ class: "bi bi-truck fs-5" }),
                                        ),
                                        h.div(
                                            {},
                                            h.div(
                                                {
                                                    class: "small text-muted fw-semibold",
                                                },
                                                "Delivery Fee",
                                            ),
                                            h.div(
                                                {
                                                    class: "fw-bold text-success fs-5",
                                                },
                                                `KES ${fee.value}`,
                                            ),
                                            v(this.deliveryDistance, (dist) => {
                                                if (dist.value === null)
                                                    return null;
                                                const distanceKm = (
                                                    dist.value / 1000
                                                ).toFixed(1);
                                                return v(
                                                    this.deliveryDuration,
                                                    (dur) => {
                                                        if (dur.value === null)
                                                            return null;
                                                        const durationMins =
                                                            Math.ceil(
                                                                (dur.value +
                                                                    600) /
                                                                    60,
                                                            );
                                                        return h.small(
                                                            {
                                                                class: "text-muted d-block mt-1",
                                                                style: "font-size: 0.8rem;",
                                                            },
                                                            h.i({
                                                                class: "bi bi-info-circle me-1",
                                                            }),
                                                            `${distanceKm} KM • ~${durationMins} mins`,
                                                        );
                                                    },
                                                );
                                            }),
                                        ),
                                    ),
                                    h.span(
                                        {
                                            class: "badge bg-success bg-opacity-25 text-success rounded-pill px-3 py-2 fw-bold",
                                        },
                                        "Est. Price",
                                    ),
                                );
                            }
                            return null;
                        }),
                    );
                }),
            ),

            h.div(
                { class: "d-flex justify-content-between mt-4 pt-2" },
                h.button(
                    {
                        type: "button",
                        class: "btn btn-outline-secondary rounded-pill px-4",
                        listeners: {
                            click: () => {
                                this.deliveryFormStep.value = 1;
                            },
                        },
                    },
                    h.i({ class: "bi bi-arrow-left me-2" }),
                    "Back",
                ),
                h.button(
                    {
                        type: "button",
                        class: "btn btn-primary rounded-pill px-4",
                        listeners: {
                            click: () => {
                                if (!this.deliveryForm.value.dropoff_address) {
                                    inform(
                                        "Please pick a dropoff address first.",
                                        STRINGS.ERROR,
                                    );
                                    return;
                                }
                                if (this.deliveryFeeError.value) {
                                    inform(
                                        this.deliveryFeeError.value,
                                        STRINGS.ERROR,
                                    );
                                    return;
                                }
                                if (this.deliveryFee.value === null) {
                                    inform(
                                        "Please wait for the delivery fee to be calculated.",
                                        STRINGS.ERROR,
                                    );
                                    return;
                                }
                                this.deliveryFormStep.value = 3;
                            },
                        },
                    },
                    "Next Step",
                    h.i({ class: "bi bi-arrow-right ms-2" }),
                ),
            ),
        );
    }

    renderStep3() {
        return h.div(
            { class: "animate-step" },
            h.h5({ class: "fw-bold mb-3 text-dark" }, "Recipient Information"),
            h.p(
                { class: "text-muted small mb-4" },
                "Please enter the contact details of the person receiving the package.",
            ),
            h.div(
                { class: "row g-3 mb-4" },
                h.div(
                    { class: "col-12" },
                    h.label(
                        {
                            class: "form-label fw-bold small text-muted text-uppercase",
                        },
                        "Recipient Name",
                    ),
                    h.input({
                        type: "text",
                        class: "form-control form-control-lg fs-5 rounded-3",
                        required: true,
                        placeholder: "e.g. John Doe",
                        value: this.deliveryForm.value.contact_name,
                        listeners: {
                            input: (e) => {
                                updateStateValue(this.deliveryForm, (v) => {
                                    v.contact_name = e.target.value;
                                    return v;
                                });
                            },
                        },
                    }),
                ),
                h.div(
                    { class: "col-12" },
                    h.label(
                        {
                            class: "form-label fw-bold small text-muted text-uppercase",
                        },
                        "Recipient Phone Number",
                    ),
                    h.input({
                        type: "tel",
                        class: "form-control form-control-lg fs-5 rounded-3",
                        required: true,
                        placeholder: "e.g. 0712345678",
                        value: this.deliveryForm.value.contact_phone,
                        listeners: {
                            input: (e) => {
                                updateStateValue(this.deliveryForm, (v) => {
                                    v.contact_phone = e.target.value;
                                    return v;
                                });
                            },
                        },
                    }),
                ),
            ),
            h.div(
                { class: "d-flex justify-content-between gap-3 mt-4 pt-2" },
                h.button(
                    {
                        type: "button",
                        class: "btn btn-outline-secondary rounded-pill px-4",
                        listeners: {
                            click: () => {
                                this.deliveryFormStep.value = 2;
                            },
                        },
                    },
                    h.i({ class: "bi bi-arrow-left me-2" }),
                    "Back",
                ),
                h.button(
                    {
                        type: "button",
                        class: "btn btn-success rounded-pill px-4 flex-fill fw-bold",
                        hook: `submit-delivery-btn-${this.id}`,
                        onclick: this.method("submitDeliveryRequest"),
                    },
                    "Request Delivery",
                ),
            ),
        );
    }
}

ojs(AuthenticatedIndex);
